import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSpinnerContext } from '../../../contexts/SpinnerContext';
import { useToastContext } from '../../../contexts/ToastContext';
import XacThucLayout from '../../../layouts/xac-thuc';
import { AccountUserModel } from '../../../models/account.model';
import apiService from '../../../services/api.service';
import { default as AuthService } from '../../../services/auth.service';
import '../index.scss';
import { getFormErrorMessage, isFormFieldValid }  from 'components/HHQComponents';
import SpinnerComponent from '../../../components/common/Spinner';
function DangKyComponent() {
    const history = useHistory();
    const { showToast } = useToastContext();
    const { isShowLoading } = useSpinnerContext();
    const { setIsShowLoading } = useSpinnerContext();
    const [step] = useState<'register' | 'otp'>('register');
    const [showPassword, setShowPassword] = useState({
        login: false,
        register: false,
        confirmRegister: false
    });

    const otpForm = useFormik({
        initialValues: {
            otp: ''
        },
        validate: (data) => {
            let errors: any = {};

            if (!data.otp) {
                errors.otp = 'Vui lòng nhập OTP nhận được';
            }
            return errors;
        },
        onSubmit: (data) => {
            handleVerifyOtp(data);
        }
    });

    const handleVerifyOtp = async (data: { otp: string }) => {
        if (!AuthService.isLoginSecret()) {
            await AuthService.secretLogin();
        }
        apiService.verifyCode({
            key: '',
            email: registerForm.values.email,
            phone: registerForm.values.phone,
            code: data.otp
        })
            .then(function (response) {
                if (response.data.status === 'error') {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                } else {
                    showToast({ severity: 'success', summary: 'Thông báo', detail: 'Đăng ký thành công', life: 3000 });
                    registerForm.resetForm();
                    history.replace('/dang-nhap')
                }
            })
            .catch(function (error) {
                showToast({ severity: 'error', summary: 'Thông báo', detail: 'Đăng ký thất bại', life: 3000 });
                console.error(error);
            });
    }

    const registerForm = useFormik({
        initialValues: {
            userName: '',
            name: '',
            phone: '',
            email: '',
            password: '',
            password_confirm: '',
            checkPolicy: false
        },
        validate: (data) => {
            let errors: any = {};
            if (!data.name) {
                errors.name = 'Nhập họ tên';
            }
            if (!data.userName) {
                errors.userName = 'Nhập tên tài khoản';
            }
            if (!/^[a-zA-Z0-9]+$/.test(data.userName)) {
                errors.userName = 'Tên tài khoản chỉ chứa các ký tự a-z và 0-9';
            }
            if (!data.email) {
                errors.email = 'Nhập Email';
            }
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
                errors.email = 'Nhập Email đúng định dạng';
            }
            if (!data.phone) {
                errors.phone = 'Nhập Số điện thoại';
            }
            if (!/(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/i.test(data.phone)) {
                errors.phone = 'Nhập số điện thoại đúng định dạng';
            }
            if (!data.password) {
                errors.password = 'Nhập mật khẩu';
            }
            if (!data.checkPolicy) {
                errors.checkPolicy = 'Bạn phải đồng ý với Điều khoản sử dụng';
            }
            if (!data.password_confirm) {
                errors.password_confirm = 'Nhập lại mật khẩu';
            }
            if (data.password !== data.password_confirm) {
                errors.password_confirm = 'Mật khẩu không trùng khớp';
            }
            return errors;
        },
        onSubmit: (data) => {
            handleRegister(data);
        }
    });

    const handleRegister = async (data: any) => {
        const saveData = new AccountUserModel();
        saveData.email = data.email;
        saveData.phone = data.phone;
        saveData.password = data.password;
        saveData.userName = data.userName;
        saveData.name = data.name;
        saveData.status = 1;
        setIsShowLoading(true);
        apiService.setAccountRegister(saveData)
            .then(function (response) {
                if (response.data.status === 'error') {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                } else {
                    // setStep('otp');
                    showToast({ severity: 'success', summary: 'Thông báo', detail: 'Đăng ký tài khoản thành công', life: 3000 });
                    setTimeout(() => {
                        history.replace('/dang-nhap');
                    }, 1500);
                }
            })
            .catch(function (error) {
                showToast({ severity: 'error', summary: 'Thông báo', detail: 'Đăng ký thất bại', life: 3000 });
                console.error(error);
            })
            .finally(() => {
                setIsShowLoading(false);
            });
    }

    const handleResendOtp = () => {
        showToast({ severity: 'error', summary: 'Thông báo', detail: 'Chức năng đang phát triển', life: 3000 });
    }

    const registerElm = (
        <form onSubmit={registerForm.handleSubmit} className="p-fluid register-wrapper">
            <div className="register-title">
                <div className="register-title--left">
                    <h2> Đăng ký </h2>
                </div>
                <div className="register-title--right">
                    <span className='subtitle'>Bạn đã có tài khoản?</span>
                    <span className='login-now' onClick={() => history.push('/dang-nhap')}>Đăng nhập ngay</span>
                </div>
            </div>
            <div className="register-form">
                <div className="form-group">
                    <div className="label">Họ tên <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-users"></i>
                        <input type="text" id="name" name="name" value={registerForm.values.name} onChange={registerForm.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'name') })} />
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'name')}
                </span>

                <div className="form-group">
                    <div className="label">Số điện thoại <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-phone"></i>
                        <input type="text" id="phone" name="phone" value={registerForm.values.phone} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'phone') })} />
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'phone')}
                </span>

                <div className="form-group">
                    <div className="label" title='Email cần nhập đúng để nhận xác nhận kích hoạt tài khoản'>Email <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-envelope"></i>
                        <input type="text" id="email" name="email" value={registerForm.values.email} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'email') })} />
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'email')}
                </span>

                <div className="form-group">
                    <div className="label" title='Tên dùng để đăng nhập vào hệ thống'>Tên đăng nhập<span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-id-card"></i>
                        <input type="text" id="userName" name="userName" value={registerForm.values.userName} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'email') })} />
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'userName')}
                </span>

                <div className="form-group">
                    <div className="label">Mật khẩu <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-unlock"></i>
                        <input id="password" name="password" type={showPassword.register ? "text" : "password"} value={registerForm.values.password} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'password') })} />
                        {
                            showPassword.register ? (
                                <i className="pi pi-eye right" onClick={() => setShowPassword({ ...showPassword, register: false })}></i>
                            ) : (
                                <i className="pi pi-eye-slash right" onClick={() => setShowPassword({ ...showPassword, register: true })}></i>
                            )
                        }
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'password')}
                </span>

                <div className="form-group">
                    <div className="label">Nhập lại khẩu <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-unlock"></i>
                        <input id="password_confirm" name="password_confirm" type={showPassword.confirmRegister ? "text" : "password"} value={registerForm.values.password_confirm} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'password') })} />
                        {
                            showPassword.confirmRegister ? (
                                <i className="pi pi-eye right" onClick={() => setShowPassword({ ...showPassword, confirmRegister: false })}></i>
                            ) : (
                                <i className="pi pi-eye-slash right" onClick={() => setShowPassword({ ...showPassword, confirmRegister: true })}></i>
                            )
                        }
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'password_confirm')}
                </span>
                <div className="register-title--right mobile">
                    <span className='subtitle'>Bạn đã có tài khoản?</span>
                    <span className='login-now' onClick={() => history.push('/dang-nhap')}>Đăng nhập ngay</span>
                </div>

                <div className="policy-wrapper">
                    <div className='policy-description'>
                        <input type='checkbox' id="checkPolicy" name="checkPolicy" checked={registerForm.values.checkPolicy} onChange={registerForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(registerForm, 'checkPolicy') })}></input> Tôi đã đọc và đồng ý với <b className='text-blue-500 pointer text-bold'> Điều khoản sử dụng</b>
                    </div>
                    <div className='policy-subDescription'>
                        <span className='text-red-500'>(*)</span> Bằng việc đăng ký bạn đồng ý để Học hiệu quả liên hệ tư vấn
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(registerForm, 'checkPolicy')}
                </span>
                <div className="register-actions">
                    <button type="submit">Đăng Ký</button>
                </div>
            </div>
        </form>
    )

    const otpElm = (
        <form onSubmit={otpForm.handleSubmit} className="p-fluid otp-wrapper">
            <div className="otp-title">
                <div className="otp-title--left">
                    <h3> Nhập mã xác nhận đã được gửi về email </h3>
                </div>
                <div className="otp-title--right">
                    <h2>
                        {registerForm.values.email || '0xxxxxx'}
                    </h2>
                </div>
            </div>
            <div className="otp-form">
                <div className="form-group">
                    <div className="label">Mã xác nhận <span className='text-red-500'> *</span></div>
                    <div className="input">
                        <i className="pi pi-users"></i>
                        <input type="text" id="otp" name="otp" value={otpForm.values.otp} onChange={otpForm.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid(otpForm, 'otp') })} />
                    </div>
                </div>
                <span className='ml-2'>
                    {getFormErrorMessage(otpForm, 'otp')}
                </span>
                <div className="otp-actions">
                    <button type="submit">Xác nhận</button>
                </div>
                <div className="resend-otp mt-3">
                    Không nhận được mã OTP? <span onClick={() => handleResendOtp()}>Gửi lại ngay</span>
                </div>
            </div>
        </form>
    )

    const renderFormElm = () => {
        if (step === 'register')
            return registerElm;
        if (step === 'otp')
            return otpElm;
    }

    return (
        <Fragment>
            <SpinnerComponent isShow={isShowLoading}></SpinnerComponent>
            <XacThucLayout>
                <div className="dang-ky">
                    {renderFormElm()}
                </div>
            </XacThucLayout>
        </Fragment>
    );
}
export default DangKyComponent;